<script>
import { isDefined } from 'comm/src/utils/utils'

export default {
  name: 'DataRange',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    separatorType: {
      type: String, // text, select
      default: 'text',
    },
    separatorText: {
      type: String,
      default: '-',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      startValue: '',
      endValue: '',
      separator: '',
    }
  },
  watch: {
    value: {
      handler(n, o) {
        if (Array.isArray(n)) {
          this.startValue = isDefined(this.value[0]) ? this.value[0] : ''
          this.endValue = isDefined(this.value[this.value.length - 1])
            ? this.value[this.value.length - 1]
            : ''
          if (this.separatorType === 'select') {
            this.separator = this.value[1]
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    clear() {
      this.dateRange = []
    },
    generateSeparator() {
      if (this.separatorType === 'text') {
        return <span class="separator">{this.separatorText}</span>
      } else if (this.separatorType === 'select') {
        return (
          <span class="separator">
            <el-select
              v-model={this.separator}
              placeholder="请选择"
              clearable
              filterable
              on={{
                change: (value) => {
                  this.$emit('input', [
                    this.startValue,
                    this.separator,
                    this.endValue,
                  ])
                },
              }}
            >
              {this.options.map((item) => {
                return (
                  <el-option
                    key={item.value}
                    label={item.label}
                    value={item.value}
                  ></el-option>
                )
              })}
            </el-select>
          </span>
        )
      }
    },
  },
  render(h) {
    return (
      <div class="data-range">
        <el-input
          v-model={this.startValue}
          on={{
            input: (value) => {
              if (this.separatorType === 'select') {
                this.$emit('input', [
                  this.startValue,
                  this.separator,
                  this.endValue,
                ])
              } else {
                this.$emit('input', [this.startValue, this.endValue])
              }
            },
          }}
          nativeOn={{
            keyup: (e) => {
              this.$emit('keyup', e)
            },
          }}
        ></el-input>
        {this.generateSeparator()}
        <el-input
          v-model={this.endValue}
          on={{
            input: (value) => {
              if (this.separatorType === 'select') {
                this.$emit('input', [
                  this.startValue,
                  this.separator,
                  this.endValue,
                ])
              } else {
                this.$emit('input', [this.startValue, this.endValue])
              }
            },
          }}
          nativeOn={{
            keyup: (e) => {
              this.$emit('keyup', e)
            },
          }}
        ></el-input>
      </div>
    )
  },
}
</script>
<style lang="scss" scoped>
.data-range {
  display: flex;
  align-items: center;
  .separator {
    margin: 0 4px;
    width: max-content;
  }
  ::v-deep .el-input {
    flex: 1;
    min-width: 70px;
    max-width: 100px;
  }
}
</style>
